// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.servant-list {
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Filters */
.filters-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: nowrap;
}

.filters {
  display: flex;
  gap: 12px;
  flex: 1 1;
}

.search-form {
  display: flex;
  gap: 8px;
  flex: 1 1;
  min-width: 300px;
}

.search-input {
  flex: 1 1;
  padding: 10px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
}

.search-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.filter-select {
  padding: 10px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  min-width: 200px;
}

.filter-select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.btn-primary {
  padding: 10px 24px;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;

  cursor: pointer;
  transition: background 0.2s;
}

.btn-primary:hover {
  background: #1d4ed8;
}

/* Stats */
.stats-bar {
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #6b7280;
}

/* Table */
.table-container {
  overflow-x: auto;
  margin-bottom: 20px;
}

.servants-table {
  width: 100%;
  border-collapse: collapse;
}

.servants-table thead {
  background: #f9fafb;
}

.servants-table th {
  padding: 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
}

.servants-table td {
  padding: 12px;
  font-size: 14px;
  border-bottom: 1px solid #e5e7eb;
}

.servants-table tbody tr:hover {
  background: #f9fafb;
}

.worship-id {
  font-weight: 600;
  color: #2563eb;
}

.name {
  font-weight: 500;
  color: #1f2937;
}

.eng-name {
  color: #6b7280;
}

.email {
  color: #6b7280;
  font-size: 13px;
}

/* Positions */
.positions-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.position-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #eff6ff;
  color: #1e40af;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.no-positions {
  color: #9ca3af;
  font-size: 13px;
  font-style: italic;
}

.btn-manage {
  padding: 6px 16px;
  background: #eff6ff;
  color: #2563eb;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.btn-manage:hover {
  background: #dbeafe;
  color: #1e3a8a;
}

/* Pagination */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px 0;
}

.btn-page {
  padding: 8px 16px;
  background: white;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-page:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #2563eb;
  color: #2563eb;
}

.btn-page:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #6b7280;
}

/* Responsive */
@media (max-width: 768px) {
  .servant-list {
    padding: 16px;
  }

  .filters-section {
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
  }

  .filters {
    flex-direction: column;
  }

  .search-form {
    min-width: 100%;
  }

  .filter-select {
    width: 100%;
  }

  .btn-primary {
    width: 100%;
  }

  .table-container {
    margin: 0 -16px;
  }

  .servants-table {
    font-size: 13px;
  }

  .servants-table th,
  .servants-table td {
    padding: 8px;
  }
}

/* ── New header/add layout ── */
.sl-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.sl-filters {
  display: flex;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}

/* Delete button */
.btn-delete {
  padding: 5px 14px;
  background: #fef2f2;
  color: #dc2626;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.btn-delete:hover {
  background: #fee2e2;
  color: #991b1b;
}

/* Loading / empty states */
.sl-loading {
  text-align: center;
  padding: 40px;
  color: #6b7280;
  font-size: 14px;
}
.sl-empty {
  text-align: center;
  padding: 32px;
  color: #9ca3af;
  font-size: 14px;
}
.sl-notes {
  color: #6b7280;
  font-size: 13px;
  max-width: 200px;
}

/* ── Add Assignment Modal ── */
.sl-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.sl-modal {
  background: white;
  border-radius: 10px;
  width: 480px;
  max-width: 95vw;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
}
.sl-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
}
.sl-modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}
.sl-modal-close {
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  color: #6b7280;
  cursor: pointer;
  padding: 0 4px;
}
.sl-modal-close:hover { color: #111827; }
.sl-modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: visible;
}
.sl-form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.sl-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}
.sl-required {
  color: #dc2626;
}
.sl-input, .sl-select, .sl-textarea {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.sl-input:focus, .sl-select:focus, .sl-textarea:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
}
.sl-textarea { resize: vertical; }

/* Autocomplete */
.sl-autocomplete {
  position: relative;
}
.sl-searching {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 13px;
  color: #6b7280;
  z-index: 200;
}
.sl-no-results {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 13px;
  color: #9ca3af;
  font-style: italic;
  z-index: 200;
}
.sl-suggestions {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 200;
  max-height: 220px;
  overflow-y: auto;
}
.sl-suggestion-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  cursor: pointer;
  font-size: 14px;
}
.sl-suggestion-item:hover { background: #f3f4f6; }
.sl-suggestion-name { font-weight: 500; color: #111827; }
.sl-suggestion-id {
  font-size: 12px;
  color: #2563eb;
  background: #eff6ff;
  padding: 1px 6px;
  border-radius: 3px;
}
.sl-suggestion-mobile { font-size: 12px; color: #6b7280; margin-left: auto; }
.sl-selected-member {
  font-size: 12px;
  color: #059669;
  margin-top: 4px;
}

.sl-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e5e7eb;
}
.sl-btn-cancel {
  padding: 8px 18px;
  background: white;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.sl-btn-cancel:hover { background: #f9fafb; }
.sl-btn-submit {
  padding: 8px 20px;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.sl-btn-submit:hover:not(:disabled) { background: #1d4ed8; }
.sl-btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }


/* ── View toggle ── */
.sl-view-toggle {
  display: flex;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}

.sl-view-btn {
  padding: 9px 16px;
  background: white;
  color: #374151;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;
}

.sl-view-btn + .sl-view-btn {
  border-left: 1px solid #d1d5db;
}

.sl-view-btn.active {
  background: #2563eb;
  color: #fff;
}

.sl-view-btn:not(.active):hover {
  background: #f3f4f6;
}
`, "",{"version":3,"sources":["webpack://./src/components/ServePositions/ServantList.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAGhB,mBAAmB;;EAEnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA,wBAAwB,cAAc,EAAE;AACxC;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;AACA,eAAe,gBAAgB,EAAE;;AAEjC,iBAAiB;AACjB;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AACA,4BAA4B,mBAAmB,EAAE;AACjD,sBAAsB,gBAAgB,EAAE,cAAc,EAAE;AACxD;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,wBAAwB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC5E;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,sCAAsC,mBAAmB,EAAE;AAC3D,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;;AAG7D,sBAAsB;AACtB;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".servant-list {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Filters */\n.filters-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: nowrap;\n}\n\n.filters {\n  display: flex;\n  gap: 12px;\n  flex: 1;\n}\n\n.search-form {\n  display: flex;\n  gap: 8px;\n  flex: 1;\n  min-width: 300px;\n}\n\n.search-input {\n  flex: 1;\n  padding: 10px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.filter-select {\n  padding: 10px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n  min-width: 200px;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.btn-primary {\n  padding: 10px 24px;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-primary:hover {\n  background: #1d4ed8;\n}\n\n/* Stats */\n.stats-bar {\n  padding: 12px 16px;\n  background: #f9fafb;\n  border-radius: 6px;\n  margin-bottom: 16px;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n/* Table */\n.table-container {\n  overflow-x: auto;\n  margin-bottom: 20px;\n}\n\n.servants-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.servants-table thead {\n  background: #f9fafb;\n}\n\n.servants-table th {\n  padding: 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.servants-table td {\n  padding: 12px;\n  font-size: 14px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.servants-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.worship-id {\n  font-weight: 600;\n  color: #2563eb;\n}\n\n.name {\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.eng-name {\n  color: #6b7280;\n}\n\n.email {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n/* Positions */\n.positions-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.position-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: #eff6ff;\n  color: #1e40af;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.no-positions {\n  color: #9ca3af;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.btn-manage {\n  padding: 6px 16px;\n  background: #eff6ff;\n  color: #2563eb;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.btn-manage:hover {\n  background: #dbeafe;\n  color: #1e3a8a;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 16px 0;\n}\n\n.btn-page {\n  padding: 8px 16px;\n  background: white;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-page:hover:not(:disabled) {\n  background: #f9fafb;\n  border-color: #2563eb;\n  color: #2563eb;\n}\n\n.btn-page:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.page-info {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .servant-list {\n    padding: 16px;\n  }\n\n  .filters-section {\n    flex-direction: column;\n    flex-wrap: wrap;\n    align-items: stretch;\n  }\n\n  .filters {\n    flex-direction: column;\n  }\n\n  .search-form {\n    min-width: 100%;\n  }\n\n  .filter-select {\n    width: 100%;\n  }\n\n  .btn-primary {\n    width: 100%;\n  }\n\n  .table-container {\n    margin: 0 -16px;\n  }\n\n  .servants-table {\n    font-size: 13px;\n  }\n\n  .servants-table th,\n  .servants-table td {\n    padding: 8px;\n  }\n}\n\n/* ── New header/add layout ── */\n.sl-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.sl-filters {\n  display: flex;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n\n/* Delete button */\n.btn-delete {\n  padding: 5px 14px;\n  background: #fef2f2;\n  color: #dc2626;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n.btn-delete:hover {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Loading / empty states */\n.sl-loading {\n  text-align: center;\n  padding: 40px;\n  color: #6b7280;\n  font-size: 14px;\n}\n.sl-empty {\n  text-align: center;\n  padding: 32px;\n  color: #9ca3af;\n  font-size: 14px;\n}\n.sl-notes {\n  color: #6b7280;\n  font-size: 13px;\n  max-width: 200px;\n}\n\n/* ── Add Assignment Modal ── */\n.sl-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n.sl-modal {\n  background: white;\n  border-radius: 10px;\n  width: 480px;\n  max-width: 95vw;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.18);\n  display: flex;\n  flex-direction: column;\n}\n.sl-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid #e5e7eb;\n}\n.sl-modal-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n.sl-modal-close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  line-height: 1;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0 4px;\n}\n.sl-modal-close:hover { color: #111827; }\n.sl-modal-body {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow: visible;\n}\n.sl-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.sl-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n}\n.sl-required {\n  color: #dc2626;\n}\n.sl-input, .sl-select, .sl-textarea {\n  width: 100%;\n  padding: 9px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n.sl-input:focus, .sl-select:focus, .sl-textarea:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37,99,235,0.1);\n}\n.sl-textarea { resize: vertical; }\n\n/* Autocomplete */\n.sl-autocomplete {\n  position: relative;\n}\n.sl-searching {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-size: 13px;\n  color: #6b7280;\n  z-index: 200;\n}\n.sl-no-results {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-size: 13px;\n  color: #9ca3af;\n  font-style: italic;\n  z-index: 200;\n}\n.sl-suggestions {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  z-index: 200;\n  max-height: 220px;\n  overflow-y: auto;\n}\n.sl-suggestion-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 12px;\n  cursor: pointer;\n  font-size: 14px;\n}\n.sl-suggestion-item:hover { background: #f3f4f6; }\n.sl-suggestion-name { font-weight: 500; color: #111827; }\n.sl-suggestion-id {\n  font-size: 12px;\n  color: #2563eb;\n  background: #eff6ff;\n  padding: 1px 6px;\n  border-radius: 3px;\n}\n.sl-suggestion-mobile { font-size: 12px; color: #6b7280; margin-left: auto; }\n.sl-selected-member {\n  font-size: 12px;\n  color: #059669;\n  margin-top: 4px;\n}\n\n.sl-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 20px;\n  border-top: 1px solid #e5e7eb;\n}\n.sl-btn-cancel {\n  padding: 8px 18px;\n  background: white;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.sl-btn-cancel:hover { background: #f9fafb; }\n.sl-btn-submit {\n  padding: 8px 20px;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.sl-btn-submit:hover:not(:disabled) { background: #1d4ed8; }\n.sl-btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }\n\n\n/* ── View toggle ── */\n.sl-view-toggle {\n  display: flex;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.sl-view-btn {\n  padding: 9px 16px;\n  background: white;\n  color: #374151;\n  border: none;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n  white-space: nowrap;\n}\n\n.sl-view-btn + .sl-view-btn {\n  border-left: 1px solid #d1d5db;\n}\n\n.sl-view-btn.active {\n  background: #2563eb;\n  color: #fff;\n}\n\n.sl-view-btn:not(.active):hover {\n  background: #f3f4f6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
